export const CAR_REVIEW_CONTENT_FILE_PATH = 'research/car-reviews/index';
